import { companyMasterApi, CompanyMasters } from '@api/masters';
import { useRequest } from './utils';

/**
 * Get the masters for company and extract a specific result.
 * @param pick The key to pick from the master response.
 */
export function useCompanyMaster<T extends keyof CompanyMasters.MasterResponse>(
  pick: T
): UseMasterReturn<CompanyMasters.MasterResponse[T]>;
/**
 * Get the masters for company.
 */
export function useCompanyMaster<
  T extends keyof CompanyMasters.MasterResponse
>(): UseMasterReturn<CompanyMasters.MasterResponse>;
/**
 * Get the masters for company.
 */
export function useCompanyMaster<T extends keyof CompanyMasters.MasterResponse>(pick?: T) {
  const { result, loading, error } = useRequest(() => companyMasterApi.getCompanyMasters(), []);
  return { loading, error, master: !loading && result && pick ? result[pick] : result };
}

interface UseMasterReturn<T> {
  readonly loading: boolean;
  readonly master: T;
  readonly error: string;
}
